import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { useTranslation } from 'react-i18next';
import { useGoogleLogin } from '../../api/queryHooks/user';
import { useAccountInfo } from '../../api/queryHooks/account';
import { Loader } from '@f2m3/shared-frontend-ui';

const GoogleButton = () => {
  const { i18n } = useTranslation();
  const { mutate: loginWithGoogle, isPending } = useGoogleLogin();
  const { data: accountInfo } = useAccountInfo();

  const google = accountInfo?.setting?.google_login;
  // Per-shop config gates this button, exactly like Facebook's: there is no
  // central Foto2Me Google client. Hidden unless the shop admin configured a
  // client id.
  if (!google?.enabled || !google.client_id) return null;

  if (isPending) return <Loader />;

  return (
    // `locale` belongs on the provider (it drives the GSI script's `hl`
    // param), not on <GoogleLogin> itself — GoogleLoginProps has no locale
    // field. Without it GIS falls back to the browser/Google-account
    // language instead of following the in-app switcher, unlike the
    // Facebook button (which renders its own translated label).
    <GoogleOAuthProvider clientId={google.client_id} locale={i18n.language}>
      <GoogleLogin
        onSuccess={(response) => {
          // credential is optional in the SDK's type; without it there is
          // nothing for the backend to verify.
          if (response.credential) loginWithGoogle({ credential: response.credential });
        }}
        onError={() => {}}
      />
    </GoogleOAuthProvider>
  );
};

export default GoogleButton;
